var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 2.00033C4.66667 1.26395 5.26362 0.666992 6 0.666992C6.73638 0.666992 7.33333 1.26395 7.33333 2.00033C7.33333 2.73671 6.73638 3.33366 6 3.33366C5.26362 3.33366 4.66667 2.73671 4.66667 2.00033Z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 2.00033C9.33333 1.26395 9.93029 0.666992 10.6667 0.666992C11.403 0.666992 12 1.26395 12 2.00033C12 2.73671 11.403 3.33366 10.6667 3.33366C9.93029 3.33366 9.33333 2.73671 9.33333 2.00033Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.00033C0 1.26395 0.596954 0.666992 1.33333 0.666992C2.06971 0.666992 2.66667 1.26395 2.66667 2.00033C2.66667 2.73671 2.06971 3.33366 1.33333 3.33366C0.596954 3.33366 0 2.73671 0 2.00033Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.b5fba3c34c133e76661e9e606234240c.svg";
export { ForwardRef as ReactComponent };